import React from "react";
import { useAuthStore } from "(store)/useAuthStore";
import useThemeStore from "(store)/themeStore";
import { useNavigate } from "react-router";
import { getInitials } from "utils";
import { useUserStore } from "(store)/useUserStore";

const UserInfo = ({ isOpen, onClick }) => {
  const navigate = useNavigate();
  const { userInfo } = useUserStore();
  const { firstName, lastName, profileImg } = userInfo;
  const theme = useThemeStore((state) => state.theme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);
  const logout = useAuthStore((state) => state.logout);
  const handleThemeChange = () => {
    toggleTheme();
    onClick();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    logout();
    navigate("/login");
  };
  return (
    <div className="relative">
      <div
        className="bg-secondary h-10 w-10 rounded-full flex justify-center border-2 border-secondary items-center text-white cursor-pointer"
        onClick={onClick}
      >
        {profileImg ? (
          <img
            src={profileImg}
            alt="User Avatar"
            className="h-full w-full object-cover rounded-full"
          />
        ) : (
          getInitials(`${firstName} ${lastName}`)
        )}
      </div>
      {isOpen && (
        <div className="absolute top-12 right-0 z-[900] w-32 bg-white text-center rounded-lg shadow-md">
          <ul className="divide-y divide-gray-200">
            <li
              className={`hover:bg-[#FBFAFA]p-2 cursor-pointer p-2 dark:text-black`}
              onClick={handleThemeChange}
            >
              {theme === "light" ? "Dark" : "Light"} mode
            </li>
            <li
              className={`hover:bg-[#FBFAFA]p-2 cursor-pointer p-2 dark:text-black`}
              onClick={handleLogout}
            >
              Logout
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserInfo;
